<div class="d-flex align-items-center justify-content-between form-group mb-3" [class]="containerStyles()">
    <div>
        <label class="mb-0 d-block fw-medium">{{ label() | translate }}</label>
        @if (description()) {
            <small class="text-muted">{{ description() | translate }}</small>
        }
    </div>
    <div class="form-check form-switch">
        <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="inputValue"
            (focus)="onTouched && onTouched()"
            (ngModelChange)="onChange && onChange(inputValue)"
            [disabled]="isDisabled">
    </div>
</div>
